import { formatPrice } from "@/shared/utils/helpers";
import { useTranslation } from "react-i18next";
import Button from "../Button/Button";
import Modal, { ModalProps } from "../Modal/Modal";
import useCashDroPaymentHook from "@/shared/hooks/useCashDroPaymentHook";
import { logCashDro } from "@/shared/utils/cashDro";
import { usePriorityModalMeta } from "@/shared/atoms/usePriorityModal";

const CashDroCancelRefundModal = ({ onExit, ...props }: ModalProps) => {
  const [{ amount, orderId }] = usePriorityModalMeta();
  const { t } = useTranslation();
  const cashDro = useCashDroPaymentHook();

  const handleRefundAnswer = (refund: boolean) => {
    logCashDro(
      refund ? "refunding the cancelled order" : "cancelled order not refunded",
      { orderId, refundAmount: amount }
    );
    if (refund) {
      cashDro.refund({
        amount: amount,
        aliasId: `O${orderId}`,
        onRefunded: async (refundedAmount, operationId) =>
          logCashDro("cancelled order refunded", {
            orderId,
            refundedAmount,
            operationId,
          }),
      });
    }
    onExit();
  };

  return (
    <Modal
      className="md:w-180"
      onExit={() => handleRefundAnswer(false)}
      {...props}
    >
      <div className="text-center p-[2rem]">
        <div className="mb-6 text-3xl font-semibold">
          {t("cashDro.refundOnCancelTitle")}
        </div>
        <div className="mb-8">
          {t("cashDro.refundOnCancelDescription", {
            amount: formatPrice(amount),
          })}
        </div>
        <div className="flex justify-center gap-4">
          <Button variant="secondary" onClick={() => handleRefundAnswer(false)}>
            {t("cashDro.noRefund")}
          </Button>
          <Button onClick={() => handleRefundAnswer(true)}>
            {t("cashDro.refundConfirm")}
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default CashDroCancelRefundModal;
